/* BuckShop AOV: geteilte Versandschwelle + kuratierte Cross-Sell-Zuordnung. */
window.BuckshopAOV = window.BuckshopAOV || {};

(function (ns) {
  ns.SHIP_THRESHOLD = ns.SHIP_THRESHOLD || 3900; // 39,00 € in Cent

  ns.fmtMoney = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  ns.escapeHtml = function (value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  };

  /**
   * Einheitlicher, datenschutzfreundlicher Messpunkt fuer AOV-Elemente.
   * Es werden ausschliesslich Produkt-/Platzierungsdaten, keine Kundendaten,
   * an vorhandene Analyse-Layer weitergereicht.
   */
  ns.track = function (eventName, details) {
    var payload = Object.assign({
      event: 'buckshop_aov',
      aov_event: eventName,
      timestamp: new Date().toISOString()
    }, details || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('buckshop:aov', { detail: payload }));

    if (typeof window.gtag === 'function') {
      try { window.gtag('event', 'buckshop_aov', payload); } catch (error) { /* optional GA bridge */ }
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish('buckshop_aov', payload); } catch (error) { /* optional analytics bridge */ }
    }
  };

  var mapPromise = null;
  function loadMap() {
    if (!mapPromise) {
      if (!ns.crossSellUrl) {
        mapPromise = Promise.resolve({});
      } else {
        mapPromise = fetch(ns.crossSellUrl)
          .then(function (r) { return r.ok ? r.json() : {}; })
          .catch(function () { return {}; });
      }
    }
    return mapPromise;
  }

  var productCache = {};
  function fetchProductOnce(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function loadProduct(handle) {
    if (productCache[handle]) return productCache[handle];

    // Ein einzelner Fehlversuch (Netzwerk-Hiccup) wird nicht dauerhaft gecacht -
    // ein kurzer Retry verhindert, dass z.B. ein Klassenstufen-Wechsel im
    // Schulstarter-Set dauerhaft "nichts passiert", nur weil ein Produkt beim
    // ersten Laden einmal nicht erreichbar war.
    var promise = fetchProductOnce(handle).then(function (result) {
      if (result) return result;
      return fetchProductOnce(handle).then(function (retryResult) {
        if (!retryResult) delete productCache[handle]; // spätere Aufrufe dürfen es erneut versuchen
        return retryResult;
      });
    });

    productCache[handle] = promise;
    return promise;
  }

  function normalizeProduct(p) {
    if (!p) return null;
    var variant = (p.variants || []).find(function (candidate) { return candidate.available; }) || (p.variants || [])[0];
    if (!variant) return null;
    return {
      handle: p.handle,
      title: p.title,
      price: variant.price,
      available: Boolean(p.available && variant.available),
      image: p.featured_image || (p.images && p.images[0]) || null,
      url: p.url,
      variantId: variant.id
    };
  }

  /**
   * Lädt ein einzelnes Produkt per Handle (gecached) in normalisierter Form.
   * @param {string} handle
   * @returns {Promise<{handle,title,price,available,image,url,variantId}|null>}
   */
  ns.loadProductByHandle = function (handle) {
    return loadProduct(handle).then(normalizeProduct);
  };

  var tagsPromise = null;
  /**
   * Lädt die kuratierte Produkt-Taxonomie (assets/buckshop-product-tags.json).
   * @returns {Promise<Object<string, {age_group, theme, occasion: string[], set_type}>>}
   */
  ns.getProductTags = function () {
    if (!tagsPromise) {
      if (!ns.productTagsUrl) {
        tagsPromise = Promise.resolve({});
      } else {
        tagsPromise = fetch(ns.productTagsUrl)
          .then(function (r) { return r.ok ? r.json() : {}; })
          .catch(function () { return {}; });
      }
    }
    return tagsPromise;
  };

  var themeLabels = {
    spiele: 'Passt zu eurem Spieleabend',
    kreativ: 'Ergänzt die kreative Auswahl',
    kuscheln: 'Passt zum Sammeln und Kuscheln',
    schule: 'Ergänzt den Schulstart',
    party: 'Macht die Party komplett',
    geschenk: 'Rundet das Geschenk ab'
  };

  var setTypeLabels = {
    'spieleabend': 'Passt zu eurem Spieleabend',
    'geschenk-fertig': 'Rundet das Geschenk ab',
    'schulstarter': 'Ergänzt den Schulstart',
    'dino-fans': 'Passt zum Dino-Thema',
    'kindergeburtstag': 'Macht die Party komplett',
    'kreativset': 'Ergänzt das Kreativ-Set',
    'topmodel-set': 'Passt zum TOPModel-Set'
  };

  function sharedOccasion(left, right) {
    var leftOccasions = (left && left.occasion) || [];
    var rightOccasions = (right && right.occasion) || [];
    return leftOccasions.some(function (occasion) { return rightOccasions.indexOf(occasion) >= 0; });
  }

  function relationFor(source, candidate, manual) {
    if (source && candidate && source.set_type && source.set_type === candidate.set_type && setTypeLabels[candidate.set_type]) {
      return setTypeLabels[candidate.set_type];
    }
    if (source && candidate && source.theme && source.theme === candidate.theme && themeLabels[candidate.theme]) {
      return themeLabels[candidate.theme];
    }
    return manual ? 'Von BUCK passend kombiniert' : 'Passt zu deiner Auswahl';
  }

  function shippingFitScore(price, context) {
    var cartTotal = Number(context.cartTotal || 0);
    var anchorPrice = Number(context.anchorPrice || 0);
    var baseTotal = cartTotal + (context.placement === 'product' ? anchorPrice : 0);
    var gap = ns.SHIP_THRESHOLD - baseTotal;
    if (gap <= 0 || !price) return 0;

    var distance = Math.abs(price - gap);
    var score = Math.max(0, 42 - Math.round(distance / 100));
    if (price >= gap && price <= gap + 800) score += 48;
    if (price < gap && price >= gap * 0.55) score += 18;
    return score;
  }

  function priceFitScore(price, context) {
    if (!price) return 0;
    if (context.placement === 'product' && context.anchorPrice) {
      var ratio = price / Number(context.anchorPrice);
      if (ratio >= 0.15 && ratio <= 0.65) return 24;
      if (ratio > 1.1) return -24;
    }
    if (context.placement === 'cart' && context.cartTotal && context.itemCount) {
      var average = Number(context.cartTotal) / Math.max(1, Number(context.itemCount));
      if (price <= average * 0.75) return 18;
      if (price > average * 1.5) return -18;
    }
    return 0;
  }

  function shippingReason(product, context) {
    var cartTotal = Number(context.cartTotal || 0);
    var anchorPrice = Number(context.anchorPrice || 0);
    var baseTotal = cartTotal + (context.placement === 'product' ? anchorPrice : 0);
    var gap = ns.SHIP_THRESHOLD - baseTotal;
    if (gap > 0 && product.price >= gap && product.price <= gap + 800) {
      return 'Schließt deine Versandlücke';
    }
    return '';
  }

  /**
   * Kontextabhaengiges Cross-Sell-Ranking. Manuelle Beziehungen bleiben die
   * staerkste Quelle; Taxonomie, Preisverhaeltnis und Versandluecke sortieren
   * anschliessend die fuer die aktuelle Situation passendsten Produkte.
   * @param {string[]} handles aktuelle Produkt-Handles
   * @param {number} [limit] maximale Anzahl Vorschlaege
   * @param {{placement?: string, cartTotal?: number, anchorPrice?: number, itemCount?: number}} [context]
   * @returns {Promise<Array<{handle,title,price,image,url,variantId,reason,score}>>}
   */
  ns.getCrossSellFor = function (handles, limit, context) {
    handles = Array.from(new Set((handles || []).filter(Boolean)));
    limit = limit || 3;
    context = context || {};
    return Promise.all([loadMap(), ns.getProductTags()]).then(function (sources) {
      var map = sources[0];
      var tags = sources[1];
      var seen = {};
      var candidates = {};
      handles.forEach(function (handle) { seen[handle] = true; });

      function addCandidate(handle, score, sourceHandle, manual) {
        if (seen[handle]) return;
        if (!candidates[handle]) {
          candidates[handle] = { handle: handle, score: 0, sources: {}, manual: false, reason: '' };
        }
        var entry = candidates[handle];
        entry.score = Math.max(entry.score, score);
        entry.sources[sourceHandle] = true;
        entry.manual = entry.manual || manual;
        if (!entry.reason) entry.reason = relationFor(tags[sourceHandle], tags[handle], manual);
      }

      handles.forEach(function (sourceHandle) {
        (map[sourceHandle] || []).forEach(function (suggestedHandle, index) {
          // Handgepruefte Produktbeziehungen muessen relevanter bleiben als
          // ein bloss preislich passender Taxonomie-Fallback.
          addCandidate(suggestedHandle, 260 - (index * 5), sourceHandle, true);
        });
      });

      // Taxonomie ergaenzt die Handarbeit und verhindert leere Module bei
      // neuen Artikeln. Mehrere Warenkorbprodukte koennen denselben Kandidaten
      // stuetzen; damit dominiert nicht mehr einfach das erste Cart-Item.
      Object.keys(tags).forEach(function (candidateHandle) {
        if (seen[candidateHandle]) return;
        handles.forEach(function (sourceHandle) {
          var source = tags[sourceHandle];
          var candidate = tags[candidateHandle];
          if (!source || !candidate) return;
          var score = 0;
          if (source.set_type && source.set_type === candidate.set_type) score += 42;
          if (source.theme && source.theme === candidate.theme) score += 28;
          if (source.age_group && source.age_group === candidate.age_group) score += 12;
          if (sharedOccasion(source, candidate)) score += 12;
          if (score >= 28) addCandidate(candidateHandle, score, sourceHandle, false);
        });
      });

      var pool = Object.keys(candidates).map(function (handle) {
        var entry = candidates[handle];
        entry.score += Math.max(0, Object.keys(entry.sources).length - 1) * 16;
        return entry;
      }).sort(function (left, right) {
        if (right.score !== left.score) return right.score - left.score;
        return left.handle.localeCompare(right.handle);
      }).slice(0, Math.max(limit * 10, 24));

      return Promise.all(pool.map(function (entry) {
        return loadProduct(entry.handle).then(function (product) {
          var normalized = normalizeProduct(product);
          if (!normalized || !normalized.available) return null;
          normalized.score = entry.score + shippingFitScore(normalized.price, context) + priceFitScore(normalized.price, context);
          normalized.reason = entry.reason;
          normalized.shippingHint = shippingReason(normalized, context);
          normalized.manual = entry.manual;
          return normalized;
        });
      })).then(function (products) {
        var available = products.filter(Boolean).sort(function (left, right) {
          if (right.score !== left.score) return right.score - left.score;
          return left.handle.localeCompare(right.handle);
        });

        // Greedy Diversitaet: nicht alle drei Plaetze mit praktisch derselben
        // Produktfamilie belegen, wenn eine gleichwertige Alternative existiert.
        var selected = [];
        var usedSetTypes = {};
        while (available.length && selected.length < limit) {
          available.sort(function (left, right) {
            var leftType = tags[left.handle] && tags[left.handle].set_type;
            var rightType = tags[right.handle] && tags[right.handle].set_type;
            var leftAdjusted = left.score - (leftType && usedSetTypes[leftType] ? 18 : 0);
            var rightAdjusted = right.score - (rightType && usedSetTypes[rightType] ? 18 : 0);
            return rightAdjusted - leftAdjusted;
          });
          var chosen = available.shift();
          var chosenType = tags[chosen.handle] && tags[chosen.handle].set_type;
          if (chosenType) usedSetTypes[chosenType] = true;
          selected.push(chosen);
        }
        return selected;
      });
    });
  };

  /**
   * Blendet ein "Zum Set"-Badge auf Produktkarten ein, die ein kuratiertes
   * Cross-Sell-Paar haben. Erwartet Markup:
   *   <div data-handle="..."> ... <span data-bs-set-badge style="display:none">...</span> ... </div>
   * @param {ParentNode} [root] - Wurzel-Element für die Suche (Standard: document)
   */
  ns.markSetBadges = function (root) {
    root = root || document;
    loadMap().then(function (map) {
      root.querySelectorAll('[data-handle]').forEach(function (card) {
        var badge = card.querySelector('[data-bs-set-badge]');
        if (badge && map[card.dataset.handle]) {
          // explizit 'inline-flex' statt '' setzen: eine leere Inline-Style
          // hebt eine CSS-Klassenregel wie "display:none" nicht auf.
          badge.style.display = 'inline-flex';
        }
      });
    });
  };
})(window.BuckshopAOV);
